import React, { Component } from "react"
import CalendarEvent from "./CalendarEvent"
import { Query } from "react-apollo"
import { Redirect } from "react-router"
import moment from "moment"
import PRODUCTS from "../../graphql/products.graphql"

import "./etrInsightsCalendar.scss"

class EtrInsightsCalendar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      month: moment.utc(),
      filters: {
        proprietaryDataset: "VENN",
        eventDateRange: {
          startDate: moment.utc().startOf("month"),
          endDate: moment.utc().endOf("month"),
        },
      },
    }
  }

  /**
   * [setMonth description]
   * update the selected month
   * this will update the state filters
   * updating the filters on state will result on a query from the db
   */
  setMonth = (month) => {
    let dateContext = Object.assign({}, month)
    this.setState({
      month: moment.utc(dateContext),
      filters: {
        proprietaryDataset: "VENN",
        eventDateRange: {
          startDate: moment.utc(dateContext).startOf("month"),
          endDate: moment.utc(dateContext).endOf("month"),
        },
      },
    })
  }

  render() {
    if (!this.props.viewer || !this.props.viewer.isUserAuthenticated) {
      return (
        <Redirect
          to={{ pathname: "/login", state: { from: "/etr-insights/calendar" } }}
        />
      )
    }
    let filters = this.state.filters
    return (
      <Query
        query={PRODUCTS}
        variables={{ filters }}
        fetchPolicy="network-only"
      >
        {({ error, data }) => {
          if (error) return `Error!: ${error}`
          return (
            <CalendarEvent
              {...this.props}
              data={data}
              fetchVennProducts={this.fetchVennProducts}
              selectedMonth={this.state.month}
              selectedDay={this.state.day}
              setMonth={(month) => this.setMonth(month)}
              setDay={(day) => this.setDay(day)}
            />
          )
        }}
      </Query>
    )
  }
}

export default EtrInsightsCalendar
